import { useEffect } from 'react'
import Box from '@mui/material/Box'
import { MapLegend, useI18n, useRouter, Select } from '@popety_io/popety-io-lib'
import LayersIcon from '@mui/icons-material/Layers'
import Tooltip from '@mui/material/Tooltip'

import { TitleRoot } from '../Legend/Legend.style'

type SelectorLegendProps = {
  options: any
  value: string
  keyValue: string
  legends?: any
}

const SelectorLegend = ({
  options,
  value,
  keyValue,
  legends,
}: SelectorLegendProps) => {
  const { t } = useI18n()

  const { updateQuery } = useRouter()

  useEffect(() => {
    return () => {
      updateQuery({ [keyValue]: undefined })
    }
  }, [])

  return (
    <MapLegend
      defaultOpen
      title={t('common.layers')}
      id="noise-legend"
      top="16px"
      icon={LayersIcon}
      zIndex={1000}
      style={{
        width: 'auto',
        overflowX: 'hidden',
        maxWidth: '250px',
      }}
      right="16px"
      left="auto"
      padding="4px"
      className="print-legend"
    >
      <Box mb="4px">
        <Select
          fullWidth
          options={options}
          value={value}
          onChange={(e: any) => updateQuery({ [keyValue]: e?.value })}
        />
      </Box>
      <Box
        sx={{ overflowY: 'auto', maxHeight: 500, padding: '8px' }}
        display="flex"
        flexDirection="column"
        gap="4px"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          gap={1}
          sx={{
            flexDirection: 'column',
          }}
        >
          {legends?.map((item: any, i: number) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <TitleRoot color={item.color} />
              <Tooltip title={item.value}>
                <span>{item.value}</span>
              </Tooltip>
            </Box>
          ))}
        </Box>
      </Box>
    </MapLegend>
  )
}

export default SelectorLegend
